module.exports = __webpack_public_path__ + "img/device.cb193dca.svg";